<template>
    <button-tooltip top :tooltip="$t('common.export')">
        <template v-slot:activator="{ on, attrs }">
            <button type="button" class="icon-button" v-bind="attrs" v-on="on" :disabled="loading" @click="run">
                <v-progress-circular v-if="loading" indeterminate size="14" width="2" />
                <v-icon v-else size="15">mdi-file-excel-outline</v-icon>
            </button>
        </template>
    </button-tooltip>
</template>

<script>
import ButtonTooltip from "@/components/common/ButtonTooltip";
import { saveWorkbook } from "@/utils/Export";
import { sheetName } from "@/utils/BusinessExport";

export default {
    name: "ExportButton",
    components: { ButtonTooltip },
    props: {
        filename: {
            type: String,
            default: 'export',
        },
        // Devuelve [{ name, aoa }] al momento del click y no como computed: son
        // varias hojas y no hace falta recalcularlas mientras nadie exporta.
        build: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        async run() {
            const vm = this
            vm.loading = true
            try {
                const sheets = await vm.build()
                if (!sheets?.length) return vm.toast(vm.$t('common.without_data'), 'error')

                const XLSX = (await import("xlsx")).default
                const workbook = XLSX.utils.book_new()
                sheets.forEach(sheet => {
                    XLSX.utils.book_append_sheet(workbook, XLSX.utils.aoa_to_sheet(sheet.aoa), sheetName(sheet.name))
                })

                const name = `${vm.filename} - ${vm.$moment().format('YYYY-MM-DD HH-mm')}`
                await saveWorkbook(XLSX, workbook, name, vm.$t('common.export'))
            } catch (error) {
                console.error('[business] export', error?.message)
                vm.toast(vm.$t('common.error_generic'), 'error')
            } finally {
                vm.loading = false
            }
        },
    },
}
</script>

<style scoped>
.icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 7px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    color: var(--v-txtSecondary-base);
    transition: color 0.15s, border-color 0.15s;
}

.icon-button:hover:not(:disabled) {
    color: var(--v-txtPrimary-base);
    border-color: var(--v-outline2-base);
}

.icon-button:disabled {
    opacity: 0.5;
}
</style>
